import { __assign } from "tslib";
import grayMatter from "gray-matter";
import mapValues from "lodash.mapvalues";
import isDate from "lodash.isdate";
export var extractFrontmatter = function extractFrontmatter(_a) {
  var source = _a.source,
      options = _a.options;

  try {
    var data = grayMatter(source.rawContent, options);

    if (data.data) {
      data.data = mapValues(data.data, function (value) {
        if (isDate(value)) {
          return value.toJSON();
        }

        return value;
      });
    }

    return {
      frontmatter: __assign({
        title: ""
      }, data.data)
    };
  } catch (e) {
    return {};
  }
};